import React, { useState } from "react";
import { useLocation } from "react-router-dom";

import MenuProvLealtad from "../ComponenProveedorLealtad/ProvMenuLealtad/ProvMenuLealtad";
import MenuPhoneLealtad from "../ComponenProveedorLealtad/ProvMenuPhoneLealtad/ProvMenuPhoneLealtad";
import ProfileProveedorLealtad from "../ProfileProveedorLealtad/ProfileProveedorLealtad";
import UpdateBillProveedorLealtad from "../UpdateBillProveedorLealtad/updateBillProveedorLealtad";
import ChangePasswordProveedorLealtad from "../ChangePasswordProveedorLealtad/ChangePasswordProveedorLealtad";
import WelcomeLealtad from "../welcomeLealtad/welcomeLealtad";

const IndexProveedor = () => {
  const [viewSeeProv, setViewPageProv] = useState(null);
  //const [alertid, setAlertId] = useState(null);
  const location = useLocation();
  let data = location.state;
  const tipeviewSee = (datos) => {
    setViewPageProv(datos);
  };

  if (!data) {
    const storedData = sessionStorage.getItem("Data");
    if (storedData) {
      data = JSON.parse(storedData);
    }
  } else {
    // Almacena los datos en sessionStorage si están disponibles
    sessionStorage.setItem("Data", JSON.stringify(data));
  }

  /*useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(process.env.REACT_APP_ALERTS_SUPPLIER);

        if (response.data.length > 0 && response.data.includes(data.id)) {
          setAlertId(data.id);
        }
      } catch (error) {
        console.error("Error al obtener los datos:", error);
      }
    };

    fetchData();
  }, [data.id]);*/

  return (
    <div className="boxprovmenuallmenulealtad">
      <MenuProvLealtad viewSee={tipeviewSee} />
      <MenuPhoneLealtad viewSee={tipeviewSee} />

      {viewSeeProv === "Perfil" ? <ProfileProveedorLealtad /> : null}
      {viewSeeProv === "Factura" ? <UpdateBillProveedorLealtad data={data} /> : null}

      {viewSeeProv === "Contraseña" ? (
        <ChangePasswordProveedorLealtad data={data} />
      ) : null}
      {viewSeeProv === null && <WelcomeLealtad data={data} />}
    </div>
  );
};

export default IndexProveedor;
